import { MessageService } from 'primeng/api';
import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpErrorCode } from '../../shared/constants/http-codes.constant';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private messageService: MessageService, private zone: NgZone) { }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleError(error: any): void {
    console.error(error); // DON'T REMOVE THIS
    if (!(error instanceof HttpErrorResponse)) {
      error = error.rejection;
    }
    if (error?.error) {
      this.zone.run(() => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: this.setMessageDetail(error),
          life: this.setMessageLife(error)
        });
      });
    }
  }

  setMessageLife(error: HttpErrorResponse): number {
    const millisecondsInSecond: number = 1000;
    // The CONFLICT error is pretty long, so we grant more time for the user to read.
    if (error?.url?.includes('/api/nomad') && error?.status === HttpErrorCode.CONFLICT) {
      return millisecondsInSecond * 10;
    }

    return millisecondsInSecond * 3;
  }

  setMessageDetail(error: HttpErrorResponse): string {
    switch (true) {
    case error?.url?.includes('bug/report'):
      return 'Bug could not be created';
    case error?.url?.includes('excel/upload-managers-teams'):
      return error?.error?.message || error?.error;
    default:
      return error?.error || error.message;
    }
  }
}
